export default "__VITE_ASSET__CBSYzCQT__"